import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Generated class for the ConfigurationPaymentRedsysBizumPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-payment-redsys-bizum',
  templateUrl: 'configuration-payment-redsys-bizum.html',
})
export class ConfigurationPaymentRedsysBizumPage {

  payment_method_redsys_merchant_code: string = '';
  payment_method_redsys_merchant_signature: string = '';
  payment_method_redsys_terminal: string = '';
  payment_method_redsys_currency: string = '';


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public analyticsServices: AnalyticsServices) {
    //notificacion de interes sobre el pay
    if (!this.globals.restaurant.payment_method_redsys_merchant_code || this.globals.restaurant.payment_method_redsys_merchant_code == undefined) {
      this.globals.sendIntegrationSlack('PAYMENT METHODS', 'OPEN REDSYS BIZUM');
    }
  }

  ionViewWillEnter() {
    if (this.globals.restaurant.payment_method_redsys_merchant_code != undefined) {
      this.payment_method_redsys_merchant_code = this.globals.restaurant.payment_method_redsys_merchant_code;
    }
    if (this.globals.restaurant.payment_method_redsys_merchant_signature != undefined) {
      this.payment_method_redsys_merchant_signature = this.globals.restaurant.payment_method_redsys_merchant_signature;
    }
    if (this.globals.restaurant.payment_method_redsys_terminal != undefined) {
      this.payment_method_redsys_terminal = this.globals.restaurant.payment_method_redsys_terminal;
    }
    if (this.globals.restaurant.payment_method_redsys_currency != undefined) {
      this.payment_method_redsys_currency = this.globals.restaurant.payment_method_redsys_currency;
    }
  }

  changeRedsysBizum(active) {
    if (this.globals.ifVarEmpty(this.payment_method_redsys_merchant_code) != ''
      && this.globals.ifVarEmpty(this.payment_method_redsys_merchant_signature) != ''
      && this.globals.ifVarEmpty(this.payment_method_redsys_terminal) != ''
      && this.globals.ifVarEmpty(this.payment_method_redsys_currency) != '') {
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_redsys_bizum': active,
        'payment_method_redsys_merchant_code': this.payment_method_redsys_merchant_code,
        'payment_method_redsys_merchant_signature': this.payment_method_redsys_merchant_signature,
        'payment_method_redsys_terminal': this.payment_method_redsys_terminal,
        'payment_method_redsys_currency': this.payment_method_redsys_currency,
      }).then(() => {
        this.globals.restaurant.payment_method_redsys_bizum = active;
        this.globals.restaurant.payment_method_redsys_merchant_code = this.payment_method_redsys_merchant_code;
        this.globals.restaurant.payment_method_redsys_merchant_signature = this.payment_method_redsys_merchant_signature;
        this.globals.restaurant.payment_method_redsys_terminal = this.payment_method_redsys_terminal;
        this.globals.restaurant.payment_method_redsys_currency = this.payment_method_redsys_currency;
      });
      if (active) {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('pay-redsys-bizum-activado'),
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      }
    } else {
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_redsys': false,
        'payment_method_redsys_bizum': false
      }).then(() => {
        this.globals.restaurant.payment_method_redsys_bizum = false;
      });
      let toast = this.toastCtrl.create({
        message: this.translate.instant('pay-redsys-bizum-no-podemos-activar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  save() {
    //activate redsys
    if (this.globals.ifVarEmpty(this.payment_method_redsys_merchant_code) != ''
      && this.globals.ifVarEmpty(this.payment_method_redsys_merchant_signature) != ''
      && this.globals.ifVarEmpty(this.payment_method_redsys_terminal) != ''
      && this.globals.ifVarEmpty(this.payment_method_redsys_currency) != '') {
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_redsys_merchant_code': this.payment_method_redsys_merchant_code,
        'payment_method_redsys_merchant_signature': this.payment_method_redsys_merchant_signature,
        'payment_method_redsys_terminal': this.payment_method_redsys_terminal,
        'payment_method_redsys_currency': this.payment_method_redsys_currency,
      }).then(() => {
        //trackingPLGPedidos
        if (this.globals.restaurant.payment_method_redsys_merchant_code !== this.payment_method_redsys_merchant_code &&
          this.globals.restaurant.payment_method_redsys_merchant_signature !== this.payment_method_redsys_merchant_signature &&
          this.globals.restaurant.payment_method_redsys_terminal !== this.payment_method_redsys_terminal &&
          this.globals.restaurant.payment_method_redsys_currency !== this.payment_method_redsys_currency) {
          this.analyticsServices.trackingExpPedidos('pay_config', this.globals.tracking_exp['pay_config']);
        }
        //set new data
        this.globals.restaurant.payment_method_redsys_merchant_code = this.payment_method_redsys_merchant_code;
        this.globals.restaurant.payment_method_redsys_merchant_signature = this.payment_method_redsys_merchant_signature;
        this.globals.restaurant.payment_method_redsys_terminal = this.payment_method_redsys_terminal;
        this.globals.restaurant.payment_method_redsys_currency = this.payment_method_redsys_currency;
        //toast save correctly
        let toast = this.toastCtrl.create({
          message: this.translate.instant('general-guardado-correctamente'),
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
        this.navCtrl.pop();
      });
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('pay-redsys-bizum-completar-campo'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-payment-methods/configuration-payment-redsys-bizum/configuration-payment-redsys-bizum.ts